import { validateUUID } from '@/lib/utils';

interface DisplayIdProps {
    id?: string | null;
    prefix?: string;
    suffix?: string;
}

/**
 *
 * This component is used to display an user frendly ID.
 * If the ID is an UUID, it will return null.
 */
export const DisplayId = ({ id, prefix, suffix }: DisplayIdProps) => {
    if (id && validateUUID(id)) {
        return null;
    }

    return (
        <>
            {prefix}
            {id}
            {suffix}
        </>
    );

    // return id;
};
